// extracted by mini-css-extract-plugin
export default {"title":"_9a4999d9","shopNow":"_5149f3ab","products":"_6e40fb81","productTile":"_c5887266","category":"_ddf96509"};